import React, { Fragment } from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import AppRoutes from './router/Routes';
import './i18n';
import './styles/index.scss';

function LandingPageApp() {
	const { t } = useTranslation();
	return (
		<Fragment>
			<AppRoutes t={t} />
			<CookieConsent
				location="bottom"
				buttonText={t('landing.common.cookies.agreeBtn')}
				cookieName="cookieConsent"
				style={{
					background: 'rgba(52, 57, 93, 0.88) 20px 50% no-repeat',
					margin: 'auto',
					alignItems: 'center',
				}}
				buttonStyle={{
					color: '#fff',
					fontSize: '16px',
					padding: '10px',
					margin: '20px 30px',
					borderRadius: '4px',
					border: '1px solid white',
					background: 'transparent',
				}}
				contentStyle={{
					margin: '10px 0 10px 30px',
				}}
			>
				<span style={{ fontWeight: 800 }}>
					{t('landing.common.cookies.title')}
				</span>
				<br />
				<span
					className="landing-cookies"
					style={{ fontSize: '16px' }}
					dangerouslySetInnerHTML={{
						__html: t('landing.common.cookies.description'),
					}}
				></span>
			</CookieConsent>
		</Fragment>
	);
}

export default LandingPageApp;
